import Phaser from 'phaser';
import BootScene from './scenes/boot';
import Breakpoints from '../../helpers/breakpoints';

function getZoom() {
  if (Breakpoints.smallTabletOrDown) return 0.6;
  if (Breakpoints.width < 900) return 0.8;
  return 1;
}

function launch() {
  return new Phaser.Game({
    type: Phaser.AUTO,
    scale: {
      mode: Phaser.Scale.NONE,
      width: 120,
      height: 210,
    },
    parent: 'site-menu',
    scene: [BootScene],
    transparent: true,
    createContainer: true,
    zoom: getZoom(),
  });
}

export { launch };
